import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
    Zap,
    Clock,
    ShieldCheck,
    HeadphonesIcon,
    Wallet,
    Sparkles,
    Dice5,
    Spade,
    Trophy,
    Gamepad2,
    Crown,
    BadgeCheck,
} from "lucide-react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const LOGIN_URL = "https://pusatcuan.app/login";

const PusatcuanLogo = ({ className = "h-16 sm:h-20 md:h-24" }) => (
    <picture>
        <source srcSet="/pusatcuan-logo.webp" type="image/webp" />
        <img
            src="/pusatcuan-logo.png"
            alt="PUSATCUAN - Link Resmi Terpercaya Slot Gacor Togel Casino Online"
            width="400"
            height="73"
            loading="eager"
            decoding="async"
            data-testid="brand-logo"
            className={`${className} w-auto object-contain mx-auto`}
        />
    </picture>
);

const HeroComposite = () => (
    <div className="pc-stage pc-stage-img" data-testid="hero-composite">
        <picture>
            <source srcSet="/pusatcuan-hero.webp" type="image/webp" />
            <img
                src="/pusatcuan-hero.jpg"
                alt="PUSATCUAN - Link resmi terpercaya slot gacor, togel, dan casino online dengan dragon emas dan koin keberuntungan"
                width="800"
                height="800"
                loading="eager"
                fetchpriority="high"
                decoding="async"
                className="pc-hero-img"
            />
        </picture>
        <div className="pc-hero-img-overlay" aria-hidden="true" />
    </div>
);

const Features = () => {
    const items = [
        {
            icon: <Zap size={22} />,
            title: "WD Kilat",
            desc: "Proses withdraw super cepat hanya dalam hitungan menit, tanpa antri panjang.",
        },
        {
            icon: <Clock size={22} />,
            title: "Layanan 24 Jam",
            desc: "Tim CS profesional siap membantu Anda non-stop, kapan pun dibutuhkan.",
        },
        {
            icon: <ShieldCheck size={22} />,
            title: "Link Resmi Terpercaya",
            desc: "PUSATCUAN adalah link resmi yang aman dan terverifikasi.",
        },
        {
            icon: <Sparkles size={22} />,
            title: "Slot Gacor Pilihan",
            desc: "Koleksi slot gacor terlengkap dari provider ternama dunia.",
        },
        {
            icon: <Wallet size={22} />,
            title: "Min. Deposit Ringan",
            desc: "Mulai dengan deposit hanya 10.000 — taruhan mulai 200 perak.",
        },
        {
            icon: <HeadphonesIcon size={22} />,
            title: "CS Responsif",
            desc: "Live chat profesional dengan respon cepat dan ramah.",
        },
    ];
    return (
        <section
            id="fitur"
            data-testid="features-section"
            className="relative py-16 sm:py-24 px-4 sm:px-6 pc-cv"
        >
            <div className="max-w-6xl mx-auto">
                <div className="mb-10 sm:mb-14">
                    <p className="text-[var(--pc-amber)] tracking-[0.3em] text-xs mb-3 uppercase">
                        Mengapa Pusat Cuan
                    </p>
                    <h2 className="pc-headline text-4xl sm:text-5xl lg:text-6xl">
                        Keunggulan Bermain di PUSATCUAN
                    </h2>
                    <p className="text-[var(--pc-muted)] text-base sm:text-lg max-w-2xl mt-4">
                        Pengalaman bermain premium dengan fitur unggulan yang dirancang
                        khusus untuk memberi Anda kenyamanan maksimal.
                    </p>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
                    {items.map((it, i) => (
                        <div
                            key={i}
                            className="pc-feature"
                            data-testid={`feature-card-${i}`}
                        >
                            <div className="pc-feature-icon">{it.icon}</div>
                            <h3 className="pc-headline text-2xl sm:text-3xl mb-2">
                                {it.title}
                            </h3>
                            <p className="text-[var(--pc-muted)] text-sm sm:text-base leading-relaxed">
                                {it.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

const Games = () => {
    const games = [
        { name: "Slot Gacor", icon: <Sparkles size={26} /> },
        { name: "Togel Online", icon: <Trophy size={26} /> },
        { name: "Live Casino", icon: <Crown size={26} /> },
        { name: "Poker Online", icon: <Spade size={26} /> },
        { name: "Sportsbook", icon: <Gamepad2 size={26} /> },
        { name: "Arcade", icon: <Dice5 size={26} /> },
    ];
    return (
        <section
            id="permainan"
            data-testid="games-section"
            className="relative py-16 sm:py-24 px-4 sm:px-6 pc-cv"
        >
            <div className="max-w-6xl mx-auto">
                <div className="mb-10 sm:mb-14">
                    <p className="text-[var(--pc-amber)] tracking-[0.3em] text-xs mb-3 uppercase">
                        Permainan
                    </p>
                    <h2 className="pc-headline text-4xl sm:text-5xl lg:text-6xl">
                        Satu Akun untuk Semua Permainan
                    </h2>
                    <p className="text-[var(--pc-muted)] text-base sm:text-lg max-w-2xl mt-4">
                        Akses penuh ke seluruh kategori permainan favorit hanya dengan satu
                        login Pusatcuan.
                    </p>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
                    {games.map((g, i) => (
                        <a
                            key={g.name}
                            href={LOGIN_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid={`game-tile-${i}`}
                            className="pc-game-tile"
                            aria-label={`Mainkan ${g.name} di Pusatcuan`}
                        >
                            <div className="icon">{g.icon}</div>
                            <div className="name">{g.name}</div>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
};

const FAQ = () => {
    const faqs = [
        {
            q: "Apa itu PUSATCUAN?",
            a: "PUSATCUAN adalah link resmi terpercaya yang menghadirkan slot gacor, togel, dan casino online dalam satu platform dengan proses WD kilat dan layanan 24 jam.",
        },
        {
            q: "Bagaimana cara melakukan Pusatcuan login?",
            a: "Cukup klik tombol LOGIN di halaman ini, Anda akan langsung diarahkan ke halaman pusatcuan login resmi. Masukkan username dan password Anda untuk mulai bermain.",
        },
        {
            q: "Bagaimana cara daftar akun baru di Pusat Cuan?",
            a: "Klik tombol DAFTAR di halaman ini, lalu isi formulir pendaftaran singkat. Akun Anda akan aktif dalam hitungan menit dan langsung bisa digunakan untuk semua permainan.",
        },
        {
            q: "Berapa minimal deposit, bet, dan withdraw di Pusatcuan?",
            a: "Minimal deposit hanya 10.000, minimal taruhan 200 perak, dan minimal withdraw 50.000. Sangat ringan dan ramah untuk semua kalangan pemain.",
        },
        {
            q: "Apakah Pusatcuan slot benar-benar gacor?",
            a: "Pusatcuan slot menggunakan provider resmi dengan RTP tinggi yang transparan, sehingga peluang menang lebih besar dan permainan tetap fair.",
        },
        {
            q: "Berapa lama proses withdraw di Pusatcuan?",
            a: "Proses WD di Pusatcuan tergolong kilat — umumnya selesai dalam beberapa menit selama jam aktif bank atau e-wallet, didukung sistem 24 jam non-stop.",
        },
    ];
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="relative py-16 sm:py-24 px-4 sm:px-6 pc-cv"
        >
            <div className="max-w-3xl mx-auto">
                <div className="mb-10 sm:mb-14 text-center">
                    <p className="text-[var(--pc-amber)] tracking-[0.3em] text-xs mb-3 uppercase">
                        FAQ
                    </p>
                    <h2 className="pc-headline text-4xl sm:text-5xl lg:text-6xl">
                        Pertanyaan yang Sering Diajukan
                    </h2>
                </div>
                <Accordion
                    type="single"
                    collapsible
                    className="space-y-3"
                    data-testid="faq-accordion"
                >
                    {faqs.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            data-testid={`faq-item-${i}`}
                            className="border border-[var(--pc-border)] rounded-xl bg-[var(--pc-card)] px-4 sm:px-5"
                        >
                            <AccordionTrigger className="text-left font-semibold text-[var(--pc-text)] hover:text-[var(--pc-amber)] py-4">
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-[var(--pc-muted)] text-sm sm:text-base leading-relaxed">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
};

const Footer = () => (
    <footer
        data-testid="site-footer"
        className="relative pt-12 pb-8 px-4 sm:px-6 border-t border-[var(--pc-border)] bg-gradient-to-b from-transparent to-black"
    >
        <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 mb-10">
                <div className="col-span-2">
                    <PusatcuanLogo className="h-12 sm:h-14" />
                    <p className="text-[var(--pc-muted)] text-sm mt-3 max-w-md">
                        PUSATCUAN — link resmi terpercaya untuk slot gacor, togel, dan
                        casino online. Pengalaman bermain premium 24 jam.
                    </p>
                </div>
                <div>
                    <h4 className="pc-headline text-xl mb-3">Tautan Cepat</h4>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <a className="pc-foot-link" href="#fitur" data-testid="footer-link-fitur">
                                Keunggulan
                            </a>
                        </li>
                        <li>
                            <a className="pc-foot-link" href="#permainan" data-testid="footer-link-permainan">
                                Permainan
                            </a>
                        </li>
                        <li>
                            <a className="pc-foot-link" href="#faq" data-testid="footer-link-faq">
                                FAQ
                            </a>
                        </li>
                    </ul>
                </div>
                <div>
                    <h4 className="pc-headline text-xl mb-3">Akses</h4>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <a
                                className="pc-foot-link"
                                href={LOGIN_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-link-login"
                            >
                                Pusatcuan Login
                            </a>
                        </li>
                        <li>
                            <a
                                className="pc-foot-link"
                                href={LOGIN_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-link-daftar"
                            >
                                Daftar Pusat Cuan
                            </a>
                        </li>
                        <li>
                            <a
                                className="pc-foot-link"
                                href={LOGIN_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-link-slot"
                            >
                                Pusatcuan Slot
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="pc-divider mb-6" />
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs sm:text-sm text-[var(--pc-muted)]">
                <p data-testid="copyright">
                    © {new Date().getFullYear()}{" "}
                    <strong className="text-[var(--pc-amber)] font-bold tracking-wide">
                        PUSATCUAN
                    </strong>{" "}
                    • All Rights Reserved.
                </p>
                <p className="flex items-center gap-2">
                    <BadgeCheck size={14} className="text-[var(--pc-amber)]" />
                    Link Resmi Terverifikasi
                </p>
            </div>
        </div>
    </footer>
);

const Home = () => {
    return (
        <div className="App relative">
            <a href="#hero" className="pc-skip-link" data-testid="skip-link">
                Lewati ke konten utama
            </a>
            <div className="pc-noise" />

            {/* Top brand bar */}
            <header
                data-testid="site-header"
                className="relative z-10 pt-10 sm:pt-14 pb-6 px-4 sm:px-6 text-center"
            >
                <h1 className="sr-only">
                    PUSATCUAN: Link Resmi Terpercaya Slot Gacor, Togel & Casino Online
                </h1>
                <PusatcuanLogo />
            </header>

            {/* Hero */}
            <main className="relative z-10 px-4 sm:px-6 pb-12">
                <section
                    id="hero"
                    data-testid="hero-section"
                    className="max-w-md sm:max-w-lg md:max-w-xl mx-auto"
                >
                    <div className="pc-hero-card">
                        <div className="pc-hero-card-inner">
                            <HeroComposite />

                            {/* Title block */}
                            <div className="px-5 sm:px-7 pt-5 pb-6 text-center">
                                <p className="pc-script text-3xl sm:text-4xl -mb-2 sm:-mb-3">
                                    Pilihan
                                </p>
                                <h2
                                    data-testid="hero-title"
                                    className="pc-headline text-3xl sm:text-4xl md:text-5xl"
                                >
                                    BANDAR SLOT ONLINE, SITUS BOLA, TOGEL, LIVE CASINO &
                                    POKER PALING FAVORIT
                                </h2>

                                <div className="mt-5 pc-info-pill" data-testid="info-pill">
                                    <span>
                                        MIN.DEPO <strong>10.000</strong>
                                    </span>
                                    <span className="sep">|</span>
                                    <span>
                                        MIN.BET <strong>200 PERAK</strong>
                                    </span>
                                    <span className="sep">|</span>
                                    <span>
                                        MIN.WEDE <strong>50.000</strong>
                                    </span>
                                </div>

                                <div className="mt-5 space-y-3">
                                    <a
                                        href={LOGIN_URL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="pc-btn pc-btn-gold"
                                        data-testid="cta-login"
                                        aria-label="Login Pusatcuan"
                                    >
                                        LOGIN
                                    </a>
                                    <a
                                        href={LOGIN_URL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="pc-btn pc-btn-red"
                                        data-testid="cta-daftar"
                                        aria-label="Daftar Pusatcuan"
                                    >
                                        DAFTAR
                                    </a>
                                </div>

                                <p className="text-[var(--pc-muted)] text-xs mt-5 tracking-wide">
                                    © {new Date().getFullYear()}{" "}
                                    <strong className="text-[var(--pc-text)]">
                                        PUSATCUAN
                                    </strong>{" "}
                                    • All Rights Reserved.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            {/* Marquee */}
            <div className="pc-marquee relative z-10" data-testid="marquee">
                <div className="pc-marquee-track">
                    PUSATCUAN • LINK RESMI TERPERCAYA • SLOT GACOR • TOGEL ONLINE • LIVE
                    CASINO • POKER • WD KILAT 24 JAM • MIN. DEPO 10.000 • PUSATCUAN LOGIN
                    • PUSAT CUAN SLOT •&nbsp;
                </div>
            </div>

            <Features />
            <Games />
            <FAQ />

            {/* Bottom CTA */}
            <section
                data-testid="bottom-cta"
                className="relative py-16 sm:py-20 px-4 sm:px-6"
            >
                <div className="max-w-3xl mx-auto text-center">
                    <h2 className="pc-headline text-4xl sm:text-5xl lg:text-6xl mb-4">
                        Siap Mulai Cuan di Pusatcuan?
                    </h2>
                    <p className="text-[var(--pc-muted)] text-base sm:text-lg mb-8">
                        Akses link resmi pusatcuan login sekarang dan rasakan sensasi
                        bermain slot gacor, togel, dan live casino dalam satu akun.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
                        <a
                            href={LOGIN_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="pc-btn pc-btn-gold"
                            data-testid="bottom-cta-login"
                        >
                            LOGIN SEKARANG
                        </a>
                        <a
                            href={LOGIN_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="pc-btn pc-btn-red"
                            data-testid="bottom-cta-daftar"
                        >
                            DAFTAR GRATIS
                        </a>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
